import { Controller } from "@hotwired/stimulus"

// Shows the admin what the voter will see on the sign-in button: the saved logo on load, and the
// locally selected file the moment one is chosen. The preview needs no upload and no round trip —
// the browser renders the chosen file straight from an object URL.
export default class extends Controller {
  static targets = ["input", "image", "empty"]

  declare inputTarget: HTMLInputElement
  declare imageTarget: HTMLImageElement
  declare emptyTarget: HTMLElement
  declare hasImageTarget: boolean
  declare hasEmptyTarget: boolean

  private objectUrl: string | null = null

  preview(): void {
    const file = this.inputTarget.files?.[0]
    if (!file) return

    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)

    if (this.hasImageTarget) {
      this.imageTarget.src = this.objectUrl
      this.imageTarget.hidden = false
    }
    if (this.hasEmptyTarget) this.emptyTarget.hidden = true
  }

  disconnect(): void {
    this.revokeObjectUrl()
  }

  // Object URLs pin the file in memory until revoked, so release the previous one on every
  // replacement and on teardown.
  private revokeObjectUrl(): void {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
